import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { Position } from "../models/position";
import { FilterPosition } from "../models/filters/filter-position";

@Injectable({
    providedIn: 'root'
  })
  export class PositionsService {
  
    constructor(private http: HttpClient) { }

    private apiUrl = `${environment.apiUrl}`;
    private url: string = this.apiUrl + 'api/positions'; 

    /*CRUD CATALOG POSITIONS*/
    /*getAllPositions(): Observable<any>{
        return this.http.get<any[]>(`${this.url}/getAllPositions`);
    }*/
   findAllPageablePositions(filterPosition: FilterPosition, page: number, pageSize: number): Observable<any> {
        return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterPosition);
    }

    getPositionById(id: number): Observable<Position>{
        return this.http.get<Position>(`${this.url}/getPositionById/${id}`)
    }

    savePosition(position: Position): Observable<Position>{
        return this.http.post<Position>(`${this.url}/savePosition`, position)
    }

    updatePosition(position: Position): Observable<Position>{
        return this.http.put<Position>(`${this.url}/updatePosition/${position.id}`, position)
    }
    /*CRUD CATALOG POSITIONS END*/

    findPositionByNumber(positionNum: string): Observable<Position> {
        return this.http.get<Position>(`${this.url}/number/${positionNum}`);
    }
}